import { PATHS } from "./paths";

export const NAV_SERVICES = [
  { to: PATHS.businessAdministration, label: "Business Administration" },
  { to: PATHS.softwareDevelopment, label: "Software Development" },
  { to: PATHS.customerSupport, label: "Customer Support" },
  { to: PATHS.salesSolutions, label: "Automated Sales" },
  { to: PATHS.marketing, label: "Digital Marketing" },
  { to: PATHS.creativeServices, label: "Creative Services" },
];

export const FOOTER_CONTACT = {
  email: "Support@extronnect.com",
  address: "3550 Moller Rd, Indianapolis, IN 46224, USA",
  salesPhone: "+1 (786) 485-0848",
  supportPhone: "+1 (310) 601-8347",
  social: [
    {
      href: "https://www.facebook.com/people/Extronnect/61557772413907/",
      src: "images/socialmediaicons/fb.png",
      alt: "fb",
    },
    {
      href: "https://www.instagram.com/extronnect/",
      src: "images/socialmediaicons/insta.png",
      alt: "insta",
    },
    {
      href: "https://x.com/extronnect",
      src: "images/socialmediaicons/twitter.png",
      alt: "twitter",
    },
    {
      href: "https://www.linkedin.com/company/extronnect/",
      src: "images/socialmediaicons/linkedin.png",
      alt: "linked in",
    },
  ],
};

export const HOME_SERVICES = [
  {
    title: "Business Administration",
    image: "images/services/op1/part2/Operationsmanagement.png",
    alt: "Operations management",
    description:
      "Streamline your operations and boost productivity with our tailored solutions.",
    to: PATHS.businessAdministration,
  },
  {
    title: "Customer Support",
    image: "images/services/op1/CustomerSupport.png",
    alt: "Customer Support",
    description:
      "Deliver exceptional service with our seamless customer support expertise.",
    to: PATHS.customerSupport,
  },
  {
    title: "Software Development",
    image: "images/services/op1/part2/Websitecreation.png",
    alt: "Website creation",
    description: "Building seamless digital experiences tailored to your brand",
    to: PATHS.softwareDevelopment,
  },
  {
    title: "Digital Marketing",
    image: "images/services/op1/part2/Marketingcmapaigns.png",
    alt: "Marketing cmapaigns",
    description:
      "Drive results and captivate your audience with our innovative Digital Marketing campaigns.",
    to: PATHS.marketing,
  },
  {
    title: "Creative Services",
    image: "images/services/op1/part2/graphicdesign.png",
    alt: "graphic design",
    description:
      "Unleash your brand's creativity and captivate your audience with our cutting-edge design expertise.",
    to: PATHS.creativeServices,
  },
  {
    title: "Automated Sales",
    image: "images/services/op1/OutsourcingSolutions.png",
    alt: "Outsourcing Solutions",
    description:
      "Elevate your business game with our expert negotiation and management solutions.",
    to: PATHS.salesSolutions,
  },
];

export const TESTIMONIALS = [
  {
    image: "images/0d22fd6e46a30758f5f777514662a564_1200_80.webp",
    quote:
      'Extronnect transformed our business with their exceptional virtual assistant services. Our productivity has skyrocketed, thanks to their efficient support." "The telemarketing solutions provided by Extronnect helped us generate quality leads and boost our Automated Sales significantly.',
    author: "Michael S - New York, NY",
    name: "Impressive Results",
  },
  {
    image: "images/photo1715887579.jpeg",
    quote:
      "I hired Extronnect and was impressed with their diligence, enthusiasm and willingness to go above and beyond. I plan to use their services again.",
    author: "Henry W - Vero Beach, FL",
    name: "Great Service",
  },
  {
    image: "images/photo1719290732.jpeg",
    quote:
      "Extronnect team has been absolutely amazing to work with. They have helped me and my business succeed and thrive! They are always there to help, their prices are fair, and their work is awesome!",
    author: "Eric L - Millersville, MD",
  },
];
